import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router, UrlTree, PRIMARY_OUTLET } from '@angular/router';
@Injectable()
export class PreventLoadingSecondaryViewGuard implements CanActivate {
  constructor(private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.isRefresh()) {
      this.router.navigateByUrl(location.pathname.slice(0, location.pathname.lastIndexOf('/')));
      return false;
    }
    return true;
  }
  private isRefresh(): boolean {
    return !this.router.navigated;
  }
}
